export default function LegalPage({ titulo, secciones }) {
    return (
        <div className="min-h-screen bg-[#0d0d0d] px-5 py-8 text-[#f5f5f5] sm:py-12">
            <div className="mx-auto max-w-3xl">
                <header className="mb-10 flex items-center justify-between border-b border-[#222] pb-6">
                    <a href="#" className="font-display text-sm font-extrabold tracking-tight" data-testid="legal-brand">
                        BIZECOM<span className="text-grad">ACADEMY</span>
                    </a>
                    <a href="#" className="btn-primary px-4 py-2 text-xs" data-testid="legal-back-link">
                        ← Volver
                    </a>
                </header>
                <h1 className="font-display text-3xl font-extrabold sm:text-4xl" data-testid="legal-title">
                    {titulo}
                </h1>
                <p className="mt-2 text-xs text-[#888]">Última actualización: septiembre 2026</p>
                <div className="mt-10 space-y-8">
                    {secciones.map((s, i) => (
                        <section key={s.titulo} data-testid={`legal-section-${i + 1}`}>
                            <h2 className="font-display text-lg font-bold text-[#ff7a30]">
                                {i + 1}. {s.titulo}
                            </h2>
                            <p className="mt-3 text-sm leading-relaxed text-[#999]">{s.texto}</p>
                        </section>
                    ))}
                </div>
                <p className="mt-14 border-t border-[#222] pt-6 text-center text-[11px] text-[#555]">
                    © 2026 BIZECOMACADEMY. Todos los derechos reservados.
                </p>
            </div>
        </div>
    );
}
